import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IIntersoftCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class IntersoftCredentialsStore implements ICredentialsStore {
    private _changes: IIntersoftCredentialsModel = {} as IIntersoftCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get customerNumber() { return this._changes.customer_number; };
    public get emailAddress() { return this._changes.email_address; };
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setEmailAddress(value: string) {
        this._changes.email_address = value;
    };

    setCustomerNumber(value: string) {
        this._changes.customer_number = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default IntersoftCredentialsStore;
